import React from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import arrow from "../../assets/ic_arrow.png"

const Insurance = ({ insurance, heading_text }) => {
  return (
    <section>
      <div className="insurance-banner">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-6 head-margin">
              <h1 className="font-proxima-nova-bold">
                <FormattedMessage
                  id="home.get-insurance"
                  defaultMessage="Get Insurance"
                  values={{ what: "react-intl" }}
                />
              </h1>
              <h2>
                {heading_text.insurance.percentage}
              </h2>
            </div>
            <div className="col-6 d-flex justify-content-center">
            </div>
          </div>
        </div>
      </div>
      <div className="container container-fluid--home-section" style={{ backgroundColor: "#FFF" }}>
        <div className="row">
          <div className="col-12">
            <h4 className="title mb-md-5 mb-3 mt-0 w-100" style={{ textAlign: "center" }}>Choose your insurance type from below</h4>
            <div className="bill-pay-icon-container">
              {insurance?.length > 0 &&
                insurance.map((item, index) => {
                  return (
                    <div className="col-12 col-sm-12 col-md-6 col-lg-4 mb-3" key={"insurance-" + index}>
                      <a rel="noopener noreferrer" href={item.url} target="_blank">
                        <div className="insurance-insurance-box" style={{ textAlign: "center" }}>
                          <img
                            src={item.web_image}
                            className="insurance-icon"
                            alt={item.title}
                          />
                          <h2>{item.title}</h2>
                          <img className="insurance-arrow" src={arrow} alt="alt" />
                        </div>
                      </a>
                    </div>
                  );
                })
              }
            </div>
            <p className="desc mt-5 text-center w-100">By clicking on any insurance, you are agreeing to the <Link to="/terms-condition">Terms & Conditions</Link></p>
          </div>
        </div>
      </div>
    </section>
  );
};

function mapDispatchToProps(dispatch) {
  return {

  };
}

function mapStateToProps(state) {
  return {
    insurance: state.home.insurance,
    heading_text: state.home.heading_text
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Insurance);

